var render, staticRenderFns
import script from "./LoadSearchLabelsMixin.vue?vue&type=script&lang=js"
export * from "./LoadSearchLabelsMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ccb993",
  null
  
)

export default component.exports